import React from 'react';
import Link from 'styles/basic/Link';

export default function LinkButton({ children, href, target='_self', ...props }) {
    return <Link href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : ''} {...props}>
        {children}
    </Link>
}